//Documentation can be found here - https://git.crasmanhosting.fi/npm/multiselect
import Multiselect from '@crasman/multiselect';

/**
 * Initialize multiselect fields
 *
 * @class multiselect
 */
class multiselect {

  constructor() {
    this.multiselect = {};
  }

  /**
   * Add approve selections button
   * @param {HTMLDivElement} list multiselect container
   */
  addApproveButton(list){
    const approveButton = document.createElement('div');
    approveButton.appendChild(document.createTextNode('Hyväksy valinnat'));
    approveButton.className = 'multiple-approve-btn';
    approveButton.style.display = 'none';

    list.parentNode.appendChild(approveButton);

    // the approveButton works as a focus shifter closing the multiselectlist
    list.addEventListener('blur', () => approveButton.style.display = 'none');
    list.addEventListener('focus', () => approveButton.style.display = 'block');
  }

  /**
   * Add and hide reset button
   * @param {HTMLSelectElement} select Single select element
   * @param {Class} multiSelect Initiated multiselect class variable
   * @param {HTMLDivElement} containerElement Container div element of single select
   */
  resetButton(select, multiSelect, containerElement) {
    // Add reset button
    const multiSelectContainer = select.closest('.' + containerElement.className)?.querySelector('.multiselect-inner-container')
    if (multiSelectContainer) {
      const multiSelectResetButton = multiSelectContainer.querySelector('.js-reset-button')
      if (!multiSelectResetButton) {

        // Check if reset button is needed by select value and add it
        if (Array.from(select.querySelectorAll('option:checked:not(disabled)')).filter(item => item.value).length === 0) {
          return false
        }

        const resetButton = document.createElement('button')
        multiSelectContainer.appendChild(resetButton)
        resetButton.classList.add('va-reset-button', 'js-reset-button')
        resetButton.ariaLabel = 'Reset'
        if (select.dataset?.resetButtonType) {
          resetButton.setAttribute('type', select.dataset.resetButtonType)
        }
        resetButton.addEventListener('click', (e) => {
          select.value = null
          multiSelect.onSelectElementChange()
          resetButton.classList.add('hidden')
          if (select.closest(`.${containerElement.className}`).getAttribute('data-dynamic-label-content')) {
            this.checkDynamicLabel(select, select.closest(`.${containerElement.className}`))
          }
        })
      } else {
        if (Array.from(select.querySelectorAll('option:checked')).filter(item => item.value).length > 0) {
          multiSelectResetButton.classList.remove('hidden')
        } else {
          multiSelectResetButton.classList.add('hidden')
        }
      }
    }
  }

  /**
   * Check and toggle class for dynamic label
   * @param {HTMLSelectElement} select Single select element
   * @param {HTMLDivElement} container Container div of select element
   */
  checkDynamicLabel(select, container) {
    if (Array.from(select.querySelectorAll('option:checked:not([disabled])')).filter(item => item.value).length > 0) {
      container.classList.add('label-move')
    } else {
      container.classList.remove('label-move')
    }
  }

  /**
   * Add error to multiselect
   * @param {HTMLSelectElement} select Single select element
   * @param {HTMLDivElement} container Container div of select element
   */
  addError(select, container) {
    const errorElement = document.createElement('div')
    container.appendChild(errorElement)
    errorElement.innerHTML = select.dataset?.showError
    errorElement.classList.add('va-form-field__error', 'va-form-field__error--show', 'va-form-field__label')
  }

  /**
   * Init multiselects
   */
  init(){
    const dropdownElements = document.querySelectorAll('.js-select, .js-multiselect');
    const settings = { listElement: { size: 12 } };
    dropdownElements.forEach(select => {

      const containerElement = {
        className: select.dataset.containerClass ?? 'va-multiselect-container'
      }

      const buttonElement = {
        idPrefix: select.dataset?.buttonIdPrefix ?? '',
        className: select.dataset?.buttonClassName ?? 'multiselect-button',
        placeholderClassName: select.dataset?.buttonPlaceholderClassName,
        preventScrollOnFocus: select.dataset?.buttonTextContent
      };

      const multiSelect = new Multiselect(select, { ...settings, buttonElement, containerElement });

      // Add extra data label for CarSearch's order multiselect
      if( select.dataset.containerClass === 'va-select-order-select' ) {
        const container = select.closest('div.va-select-order-select');
        const button = container?.querySelector('button.multiselect-button')
        button?.setAttribute('data-label', select.dataset.buttonLabel);
      }

      // Close after every selection
      select.addEventListener('change', () => {
        select.blur()
        multiSelect.closeOptionsList()
        if (select.dataset?.resetButton) {
          this.resetButton(select, multiSelect, containerElement)
        }
      })

      if (select.dataset?.resetButton) {
        if (Array.from(select.querySelectorAll('option:checked')).filter(item => item.value).length > 0) {
          this.resetButton(select, multiSelect, containerElement)
        }
      }

      if (select.dataset?.dynamicLabel) {
        const container = select.closest(`.${containerElement.className}`);
        const label = container?.querySelector('.multiselect-label')
        const button = container?.querySelector('.multiselect-button')
        container.setAttribute('data-dynamic-label-content', button.getAttribute('data-placeholder'))
        label.classList.add('sr-only')
        select.addEventListener('change', () => {
          this.checkDynamicLabel(select, container)
        })
        this.checkDynamicLabel(select, container)
      }

      if (select.dataset?.showError) {
        const container = select.closest(`.${containerElement.className}`);
        this.addError(select, container)
      }

      // Removed as client did not want this anymore.
      // Add approve selection button to multiple selection lists
      // const multipleSelectList = select.parentNode.querySelector('.multiselect-list.multiple');
      // if (multipleSelectList) {
      // this.addApproveButton(multipleSelectList);
      // }
    });

  }
}


export default new multiselect()

